export default (options) =>		// [{ hash: '#hash', label: 'label' }]
`<ul class="menu submenu">
	${options.map(option => `<li hash="${option.hash}">${option.label}</li>`).join('')}
</ul>`;

